<ion-header>
    <ion-toolbar>
        <ion-item lines="none" color="secondary">
            <ion-label>{{ 'Tracking mode' | translate }}</ion-label>
        </ion-item>
    </ion-toolbar>
</ion-header>
<ion-content>
    <form [formGroup]="form">
        <ion-list>
            <ion-item>
                <ion-toggle formControlName="rallyLength">{{ 'Rally length' | translate }} </ion-toggle>
            </ion-item>
            <ion-item>
                <ion-toggle formControlName="serveLocation">{{ 'Serve location' | translate }}</ion-toggle>
            </ion-item>
            <ion-button class="ion-margin" (click)="update()" expand="block">
                <span *ngIf="!updating">{{ 'Update' | translate }}</span>
                <ion-spinner name="crescent" *ngIf="updating"></ion-spinner>
            </ion-button>
        </ion-list>
    </form>
</ion-content>
